import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { detectedCountryCodeSelector, customerConfigSelector, } from '@planter/common/src/redux';
import { isFeatureEnabled } from '@planter/common/src/utils/config.utils';
import packageJson from '../../package.json';
/**
 * Hook per verificare se una feature è abilitata su WEB
 * @param featureName - Nome della feature (es. "lunchbox")
 */
export var useFeatureFlag = function (featureName) {
    var customerConfig = useSelector(customerConfigSelector);
    var detectedCountryCode = useSelector(detectedCountryCodeSelector);
    var isEnabled = useMemo(function () {
        if (!customerConfig) {
            return false;
        }
        var currentVersion = packageJson.version;
        return isFeatureEnabled(customerConfig, featureName, 'web', currentVersion, detectedCountryCode);
    }, [customerConfig, detectedCountryCode, featureName]);
    return {
        isEnabled: isEnabled,
    };
};
